<script setup>import { ref as _ref, computed as _computed } from 'vue';

  import { onMounted, onUnmounted } from "vue";
  import LineItemsTable from "./line-items/line-items-table.vue";
  import OrderItemInventoryCombobox from "./order-item-inventory-combobox.vue";
  import SupplierInventoryPicker from "./supplier-inventory-picker.vue";
  import { createOrderItem, updateOrderItem, deleteOrderItem } from "./api/order-items.js";

  const props = defineProps({
    items: { type: Array, required: true },
    userId: { type: Number, required: true },
    orderId: { type: Number, required: true },
  });

  let supplierId = _ref(null);
  let orderSupplierId = _ref(null);
  let orderSupplierName = _ref(null);

  const comboboxProps = _computed(() => ({ userId: props.userId, supplierId: supplierId.value }));

  const api = {
    create: (attributes) => createOrderItem(props.orderId, attributes),
    update: (id, attributes) => updateOrderItem(props.orderId, id, attributes),
    remove: (id) => deleteOrderItem(props.orderId, id),
  };

  const labels = {
    model: "Order item",
    removeTitle: "Remove Item",
    removeMessage: "Are you sure you want to remove this item from the order?",
  };

  function mapSelection(inventory) {
    return {
      itemId: inventory.id,
      name: inventory.ingredient.name,
      customName: inventory.custom_name,
      unit: inventory.unit,
      units: inventory.ingredient.units,
    };
  }

  function onSupplierFilterChanged({ detail }) {
    supplierId.value = detail.supplierId;
  }

  function onOrderSupplierChanged({ detail }) {
    orderSupplierId.value = detail.supplierId;
    orderSupplierName.value = detail.supplierName;
  }

  onMounted(() => {
    const select = document.querySelector("#purchase_order_supplier_id");
    if (select) {
      orderSupplierId.value = +select.value || null;
      const option = select.options[select.selectedIndex];
      orderSupplierName.value = option ? option.text : null;
    }
    document.addEventListener("supplier-filter-changed", onSupplierFilterChanged);
    document.addEventListener("order-supplier-changed", onOrderSupplierChanged);
  });

  onUnmounted(() => {
    document.removeEventListener("supplier-filter-changed", onSupplierFilterChanged);
    document.removeEventListener("order-supplier-changed", onOrderSupplierChanged);
  });

  function onSavedCountChanged(count) {
    document.dispatchEvent(new CustomEvent("order-items-changed", { detail: { count } }));
  }

  function onUnsavedChanged(hasUnsaved) {
    document.dispatchEvent(new CustomEvent("order-items-has-unsaved", { detail: { hasUnsaved } }));
  }

  function pickedItem(inventory) {
    return {
      id: null,
      item_id: inventory.id,
      item_name: inventory.ingredient.name,
      item_custom_name: inventory.custom_name,
      quantity: "",
      unit: inventory.unit,
      units: inventory.ingredient.units,
    };
  }
</script>

<template>
  <LineItemsTable
    :items="items"
    :item-combobox="OrderItemInventoryCombobox"
    :combobox-props="comboboxProps"
    :map-selection="mapSelection"
    :api="api"
    :labels="labels"
    @saved-count-changed="onSavedCountChanged"
    @unsaved-changed="onUnsavedChanged"
  >
    <template #footer="{ excludedItemIds, addItems }">
      <div class="mt-4">
        <SupplierInventoryPicker
          :user-id="userId"
          :supplier-id="orderSupplierId"
          :supplier-name="orderSupplierName"
          :excluded-item-ids="excludedItemIds"
          @add="addItems($event.map(pickedItem))"
        />
      </div>
    </template>
  </LineItemsTable>
</template>
